import { AppModalLocale } from "../index";

const locale: AppModalLocale = {
  name: '名称',
  code: '编码',
  type: '类型',
  desc: '描述',
};

export default locale
